<template>
  <el-dialog
    class="dialog-container"
    :title="$t('zlfk.ckqb')"
    :visible.sync="dialogVisible"
    width="550px"
    append-to-body
  >
    <div slot="title" class="header-title">
      <img src="@/assets/image/vinCode.png" alt="" />
      <span>{{ $t('zlfk.ckqb') }}</span>
    </div>
    <!-- 表格内容 -->
    <div class="table-container">
      <el-table
        ref="tableRef"
        stripe
        border
        highlight-current-row
        :data="vinList"
      >
        <!-- 序号 -->
        <el-table-column
          :label="$t('cart.xh')"
          width="60px"
          align="center"
          type="index"
          :render-header="$globalRenderHeader"
        ></el-table-column>
        <!-- 故障车VIN码 -->
        <el-table-column
          prop="vin"
          :label="$t('zlfk.gzcvin')"
          min-width="120px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="vinCreated"
          :label="$t('seek.produceDate')"
          min-width="120px"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
      vinList: [],
    };
  },
  mounted() {},
  methods: {
    // 初始化
    async init(data = []) {
      this.vinList = data || [];
      this.dialogVisible = true;
    },
  },
};
</script>
